<app-card [title]="'user.editUser.labels.paymentDetails'" titleSize="large">
    <ng-template #content>
        @if (form()) {
            <div class="input-grid-gaps grid-12col p-1">
                <app-text-input
                    id="accountPrefix"
                    class="fr-3"
                    label="inputs.account.prefix"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="accountNumber"
                    class="fr-6"
                    label="inputs.account.number"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="accountBankCode"
                    class="fr-3"
                    label="inputs.account.bankCode"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="variableSymbol"
                    class="fr-4"
                    label="inputs.account.variableSymbol"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="specificSymbol"
                    class="fr-4"
                    label="inputs.account.specificSymbol"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="constantSymbol"
                    class="fr-4"
                    label="inputs.account.constantSymbol"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>

                <app-text-input
                    id="messageForRecipient"
                    class="fr-12"
                    label="inputs.account.messageForRecipients"
                    [form]="form()"
                    [disabled]="!canEdit()">
                </app-text-input>
            </div>
        }
    </ng-template>
</app-card>
